import { render, staticRenderFns } from "./ContactRoleForm.vue?vue&type=template&id=b90a4204&scoped=true&"
import script from "./ContactRoleForm.vue?vue&type=script&lang=js&"
export * from "./ContactRoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90a4204",
  null
  
)

export default component.exports